<!--https://codepen.io/quinlo/pen/YONMEa-->
<div class="container preload">
  <div appFlipCardOnClick class="creditcard">
    <div class="front">
      <div id="ccsingle"></div>
      <svg id="cardfront" style="enable-background:new 0 0 750 471;" version="1.1" viewBox="0 0 750 471" x="0px"
        xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
        <g id="Front">
          <g id="CardBackground">
            <g id="Page-1_1_">
              <g id="amex_1_">
                <path class="lightcolor primary" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                              C0,17.9,17.9,0,40,0z" id="Rectangle-1_1_" />
              </g>
            </g>
            <path class="darkcolor greendark"
              d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z" />
          </g>
          <text class="st2 st3 st4 iban" id="svgnumber" transform="matrix(1 0 0 1 60.106 295.0121)">
            {{ this.IBAN }}</text>
          <text class="st2 st5 st6" id="svgname" transform="matrix(1 0 0 1 54.1064 428.1723)">{{ this.name
            }}</text>
          <text class="st7 st5 st8" transform="matrix(1 0 0 1 54.1074 389.8793)">{{this.nameText}}</text>
          <text class="st7 st5 st8" transform="matrix(1 0 0 1 479.7754 388.8793)">{{this.expirationText}}</text>
          <text class="st7 st5 st8 ibanText" transform="matrix(1 0 0 1 65.1054 241.5)">{{this.IBAN_Text}}</text>
          <g>
            <text class="st2 st5 st9" id="svgexpire" transform="matrix(1 0 0 1 574.4219 433.8095)">{{
              this.expirationDate }}
            </text>
            <text class="st2 st10 st11" transform="matrix(1 0 0 1 459.3848 417.0097)">Gültig</text>
            <text class="st2 st10 st11" transform="matrix(1 0 0 1 459.3848 435.6762)">bis</text>
            <polygon class="st2" points="559.5,421 545.4,414.2 545.4,427.9 		" />
          </g>
          <g id="cchip">
            <image href="assets/img/BimSWARM-logo.png" x="20" y="20" width="150" height="100" />

          </g>
        </g>
        <g id="Back">
        </g>
      </svg>
    </div>
    <div class="back">
      <svg id="cardback" style="enable-background:new 0 0 750 471;" version="1.1" viewBox="0 0 750 471" x="0px"
        xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px">
        <g id="Front">
          <line class="st0" x1="35.3" x2="36.7" y1="10.4" y2="11" />
        </g>
        <g id="Back">
          <g id="Page-1_2_">
            <g id="amex_2_">
              <path class="darkcolor greendark" d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                          C0,17.9,17.9,0,40,0z" id="Rectangle-1_2_" />
            </g>
          </g>
          <rect class="st2" height="78" width="750" y="61.6" />
          <g>
            <path class="st3" d="M701.1,249.1H48.9c-3.3,0-6-2.7-6-6v-52.5c0-3.3,2.7-6,6-6h652.1c3.3,0,6,2.7,6,6v52.5
                      C707.1,246.4,704.4,249.1,701.1,249.1z" />
            <rect class="st4" height="10.5" width="664.1" x="42.9" y="198.6" />
            <rect class="st4" height="10.5" width="664.1" x="42.9" y="224.5" />
            <path class="st5"
              d="M701.1,184.6H618h-8h-10v64.5h10h8h83.1c3.3,0,6-2.7,6-6v-52.5C707.1,187.3,704.4,184.6,701.1,184.6z" />
          </g>
          <text class="st6 st7" id="svgsecurity" transform="matrix(1 0 0 1 621.999 227.2734)">{{
            this.securityCode }}</text>
          <g class="st8">
            <text class="st9 st6 st10" transform="matrix(1 0 0 1 518.083 280.0879)">{{this.securityCodeText}}</text>
          </g>
          <rect *ngIf="!this.cardNumber" class="st11" height="13.5" width="375.5" x="58.1" y="378.6" />
          <text *ngIf="this.cardNumber" class="st11" height="13.5" style="font-size: 3rem" width="375.5" x="58.1"
            y="378.6">{{this.cardNumberText}} {{ this.cardNumber.toString() }}</text>
          <rect class="st11" height="13.5" width="421.7" x="58.1" y="405.6" />
          <text class="st12 st13" id="svgnameback" transform="matrix(1 0 0 1 59.5073 228.6099)">{{ this.name
            }}</text>
        </g>
      </svg>
    </div>
  </div>
</div>
